import React from 'react'

export default function CloseIcon() {
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 7.434L2.618 3.71L0.014 0H1.064L3.458 3.43H2.828L5.208 0H6.258L3.654 3.71L6.258 7.434H5.208L2.828 3.99H3.458L1.05 7.434H0Z"
        fill="black"
      />
    </svg>
  )
}
